var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustrated-error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 650",
    d: "M131.584 32C137.306 32 141.861 36.7917 141.571 42.5059L135.441 163.506C135.172 168.825 130.78 173 125.454 173H108.546C103.22 173 98.8281 168.825 98.5586 163.506L92.4287 42.5059C92.1393 36.7917 96.6945 32 102.416 32H131.584Z",
    fill: "var(--fill-0, white)",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 117,
    cy: 197,
    r: 17,
    fill: "var(--fill-0, white)",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 649",
    d: "M106.426 47.4048C106.194 42.8334 109.838 39 114.416 39H143.584C148.162 39 151.806 42.8334 151.574 47.4048L145.444 168.405C145.228 172.66 141.715 176 137.454 176H120.546C116.285 176 112.772 172.66 112.556 168.405L106.426 47.4048Z",
    fill: "var(--fill-0, #FFDAD6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 129,
    cy: 202,
    r: 15,
    fill: "var(--fill-0, #FFDAD6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 650_2",
    d: "M131.584 32C137.306 32 141.861 36.7917 141.571 42.5059L135.441 163.506C135.172 168.825 130.78 173 125.454 173H108.546C103.22 173 98.8281 168.825 98.5586 163.506L92.4287 42.5059C92.1393 36.7917 96.6945 32 102.416 32H131.584Z",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34_2",
    cx: 117,
    cy: 197,
    r: 17,
    stroke: "var(--stroke-0, black)",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationError);
export default __webpack_public_path__ + "static/media/illustration_error.b38d4516881e2ecce731da6cb3238185.svg";
export { ForwardRef as ReactComponent };